import { render, staticRenderFns } from "./ThreeColumnsLayout.vue?vue&type=template&id=24f60fc6&"
import script from "./ThreeColumnsLayout.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnsLayout.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumnsLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports